import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=c25d8e7c&scoped=true"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=c25d8e7c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25d8e7c",
  null
  
)

export default component.exports